// Toast hook. Returns { toasts, show } where:
//   toasts: array of { id, msg, type } currently on screen
//   show:   (msg, type?) -> void; type ∈ "ok" | "warn" | "remove"
//
// Toasts auto-dismiss after 2.8s. Rendering is the caller's job.

import { useState } from "react";

export function useToast() {
  const [toasts, setToasts] = useState([]);
  const show = (msg, type = "ok") => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, msg, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 2800);
  };
  return { toasts, show };
}
